/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-child-element-spacing */
import React, { Component } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { commonStyleForDetail } from '../Common/CommonStyle';
import ErrorOutlineOutlined from '@material-ui/icons/ErrorOutlineOutlined';
import { hot } from 'react-hot-loader';

class LinkExpired extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		// NOSONAR
		const { classes } = this.props;

		return (
			<Container component="main" maxWidth="sm">
				<Paper className={classes.paper}>
					<div className={classes.root}>
						<Grid container id="reduce-width" spacing={5}>
							<section>
								<Container
									component="main"
									maxWidth="md"
									style={{ textAlign: 'center', paddingTop: '3rem', color: '#595959' }}>
									<ErrorOutlineOutlined style={{ transform: 'scale(3.8)', color: '#f8bb86' }} />
									<h3 style={{ paddingTop: '1.5rem', fontWeight: '600', wordWrap: 'break-word' }}>
										{this.props.reason == 'expired'
											? `The Request link has been expired!`
											: `Invalid Link!`}
									</h3>
								</Container>
							</section>
						</Grid>
					</div>
				</Paper>
			</Container>
		);
	}
}

export default hot(module)(withStyles(commonStyleForDetail)(LinkExpired));
